import { FileInputStatus } from '../types/FileUpload';

// 未設定の選択肢のvalue値
export const not_submitted_value = '00000';

// マスク機能、画像プレビューのホワイトリスト
export const mime_type_white_list = [
  'image/jpeg',
  'image/gif',
  'image/png',
  'image/bmp',
  'image/heif',
  'image/heic',
];

// 書類棚のStateの初期値
export const init_shelf_state = {
  index: 0,
  is_uploaded: false,
  // 追加したファイルの情報
  file: {
    file_name: '',
    img: '', // Base64
    file_body: '', // Blob
    width: 0,
    height: 0,
    mime: '',
  },
  // アップロードしたファイルの情報
  s3_info: {
    file_name: '',
  },
  document_type: not_submitted_value, // 書類種別の選択状態
  document_status: '未提出', // 提出状態
  submission_date: '', // 提出日時
  errors: {
    document_type: '',
    file_required: '',
  },
};

// 棚単位のStateの初期設定
export const init_shelfs = {
  shelf_cd: '',
  document_type_source: [],
  can_mask: false,
  file_data: [{ ...init_shelf_state }] as FileInputStatus[],
};

// 書類提出の未提出状態
export const document_status = {
  no_submission: '未提出',
};

// 案件情報の初期状態
export const init_reception = {
  reception_id: 0,
  reception_cd: '',
  reception_sub_cd: '',
  ident_lv1_cd: '',
  ident_lv2_cd: '',
  ident_lv3_cd: '',
  status_code: 0,
};

export const preview_modal_init = {
  is_show: false,
  image_source: '',
  image_height: 0,
  image_width: 0,
};

// 書類種別初期値
export const default_document_type = '00000';

// 棚の開閉状態の初期状態
export const default_shelf_open = {
  A:  false,
  B:  false,
  C:  false,
  D:  false,
  E:  false,
  F:  false,
  G:  false,
  H:  false,
  I:  false,
  J:  false,
  K:  false,
  AA: false,
  AB: false,
  AC: false,
  AD: false,
  AE: false,
  AF: false,
  AG: false,
  AH: false,
  AI: false,
  AJ: false,
  AK: false,
  AL: false,
  AM: false,
  AN: false,
  AO: false,
  AP: false,
  AQ: false,
  AR: false,
  AS: false,
  AT: false,
  AU: false,
  AV: false,
  AW: false,
  AX: false,
  AY: false,
  AZ: false,
  BA: false,
  BB: false,
  BC: false,
  BD: false,
  BE: false,
  BF: false,
  BG: false,
  BH: false,
  BI: false,
}

// 棚の状態保存を実行する処理モード
export const process_upload = 'upload';

// 書類提出者番号
export const proposer_cd = {
  applicant: '1',
  guarantor1: '2',
  guarantor2: '3',
  guarantor3: '4',
  guarantor4: '5',
  guarantor5: '6',
  guarantor6: '7',
  guarantor7: '8',
  guarantor8: '9',
  guarantor9: '10',
  guarantor10: '11',
  guarantor11: '12',
  guarantor12: '13',
  guarantor13: '14',
  guarantor14: '15',
  guarantor15: '16',
  guarantor16: '17',
  guarantor17: '18',
  guarantor18: '19',
  guarantor19: '20',
  guarantor20: '21',
};
